type TipoFiltro = "ideal" | "tolerancia" | "fora" | "todos";

type FiltroTipoProps = {
  value: TipoFiltro;
  onChange?: (value: TipoFiltro) => void;
};

export default function FiltroTipo({ value, onChange }: FiltroTipoProps) {
  const itens: { key: TipoFiltro; label: string }[] = [
    { key: "ideal", label: "Peso ideal" },
    { key: "tolerancia", label: "Peso na tolerância" },
    { key: "fora", label: "Peso fora dos limites" },
    { key: "todos", label: "Todos" },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {itens.map((i) => (
        <button
          key={i.key}
          type="button"
          onClick={() => onChange?.(i.key)}
          className={`px-3 py-1 rounded-md border ${
            value === i.key
              ? "bg-slate-900 text-white"
              : "bg-white text-slate-700"
          }`}
        >
          {i.label}
        </button>
      ))}
    </div>
  );
}
